import {AwsRum} from 'aws-rum-web';

import appConfig from '../../../configs/appConfig';
import awsRumSessionAttribute from '../../../consts/aws/awsRumSessionAttribute';
import envVariables from '../../../consts/envVariables';
import rumCustomEventsHelpers from '../../events/rumCustomEventsHelpers';
import log from '../../logger/log';
import awsAuthService from '../awsAuthService';
import rum_config from './config';

let awsRum;

const initAwsRum = () => {
    try {
        awsRum = new AwsRum(
            rum_config.APPLICATION_ID,
            rum_config.APPLICATION_VERSION,
            rum_config.APPLICATION_REGION,
            rum_config.config
        );

        disable();
    } catch (e) {
        log.error(`awsRumService: Rum error handler: ${e}`, e);
    }
};

const recordError = (error) => awsRum.recordError(Error(error));

const recordPage = (path, tags = []) => awsRum.recordPageView({pageId: path, pageTags: tags});

const enable = () => {
    // disable RUM push and store events for development mode and unsupported environments
    if (import.meta.env.DEV || !envVariables.AWS_RUM_APPLICATION_ID) {
        awsRum.disable();
    }
    rumCustomEventsHelpers.resumePushEvents();
    awsRum.enable();
};

const disable = () => {
    rumCustomEventsHelpers.pausePushEvents();
    awsRum.disable();
};

const recordCustomEvents = (type, eventData) => awsRum.recordEvent(type, eventData);

const addSessionAttribute = (property, value) => awsRum.addSessionAttributes({[property]: value});

const setAwsCredentials = (cred = null) => awsRum.setAwsCredentials(cred);

const resetAnalyticsSession = () => rumCustomEventsHelpers.resetSessionId();

const addSessionAttributes = async () => {
    try {
        resetAnalyticsSession();

        const cognitoSession = await awsAuthService.getCurrentSession();

        const location =
            cognitoSession?.idToken?.payload?.locationId === 'null'
                ? null
                : cognitoSession?.idToken?.payload?.locationId;
        const cognitoUser = cognitoSession?.idToken?.payload?.['cognito:username'];
        const market = appConfig.getMarket();
        const userAgent = navigator.userAgent;
        const env = envVariables.ENV;

        awsRumService.addSessionAttribute(awsRumSessionAttribute.VERSION, rum_config.APPLICATION_VERSION);
        if (market) {
            awsRumService.addSessionAttribute(awsRumSessionAttribute.MARKET, market);
        }

        if (cognitoUser) {
            awsRumService.addSessionAttribute(awsRumSessionAttribute.USER, cognitoUser);
        }

        if (location) {
            awsRumService.addSessionAttribute(awsRumSessionAttribute.STORE, location);
        }

        if (userAgent) {
            awsRumService.addSessionAttribute(awsRumSessionAttribute.USER_AGENT, userAgent);
        }

        if (env) {
            awsRumService.addSessionAttribute(awsRumSessionAttribute.ENV, env);
        }
    } catch (e) {
        log.error('awsRumService: Failed to set session attribute', e);
    }
};

const awsRumService = {
    initAwsRum,
    recordError,
    recordPage,
    enable,
    disable,
    setAwsCredentials,
    recordCustomEvents,
    addSessionAttribute,
    addSessionAttributes,
    resetAnalyticsSession,
};

export default awsRumService;
